import { forwardRef, useRef } from "react";
import { Form } from "react-bootstrap";
import { reducerActions } from "../../../Reducers/FormReducer";

const DropdownBase = forwardRef((props, ref) => {

  const inputRef = useRef();
  const {
    field,
    objectkey,   
    options,
    error,
    touched,
    dispatchState
  } = props;

  const handleChange = (event) => {
    dispatchState({ 
      type: reducerActions.ON_CHANGE_DROPDOWN, 
      payload: { 
        key:objectkey,
        value: event.target.value 
      } 
    });
  };

  const handleBlur = () => {
    dispatchState({
      type: reducerActions.ON_BLUR_DROPDOWN,
        payload: { 
          key:objectkey       
        } 
    });    
  };

  return (
    <>
      <label htmlFor={field.fieldId}>
        {field.fieldLabel || field.fieldName}
        {field.fieldRequired && <span className="text-danger">*</span>}
        &nbsp;
      </label>
      <span className="input-wrapper">
        <Form.Select
          ref={inputRef}
          type={field.fieldType}
          id={field.fieldId}
          value={field.fieldValue || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          required={field.fieldRequired}
          maxLength={field.maxLength > 0 ? field.maxLength : 999}
          isInvalid={touched && (!!error || !field.isValid)}
        >
          <option value=""></option>
             {options.map((key, index) =>{
               return (
                 <option key={index} value={key}>
                   {key}
                 </option>
               );
             })}
          </Form.Select>
       {error && (
        <Form.Control.Feedback type="invalid">
          {error}
        </Form.Control.Feedback>
      )}
      </span>
    </>
  );
});

export default DropdownBase;